import { render } from "./CreateArticle.vue?vue&type=template&id=0766b8dc&ts=true"
import script from "./CreateArticle.vue?vue&type=script&lang=ts"
export * from "./CreateArticle.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__